import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04bacc4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fs-5 mb-0" }
const _hoisted_2 = {
  key: 0,
  class: "fs-6 fst-italic"
}
const _hoisted_3 = { class: "buttons d-flex justify-content-end align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "restart_alt", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm btn-icon btn-primary ms-2",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "search")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_card_header = _resolveComponent("base-card-header")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_SelectBrands = _resolveComponent("SelectBrands")!
  const _component_SelectTrademarks = _resolveComponent("SelectTrademarks")!
  const _component_SelectCategories = _resolveComponent("SelectCategories")!
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!
  const _component_base_card_body = _resolveComponent("base-card-body")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_dp_form = _resolveComponent("dp-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.criteriaUI.getError()
    }, null, 8, ["error"]),
    _createVNode(_component_dp_form, {
      as: "form",
      novalidate: "",
      onSubmit: _ctx.triggerSearch
    }, {
      default: _withCtx(({ errors }) => [
        _createVNode(_component_base_card, {
          class: _normalizeClass(["criteria", {'is-changed': _ctx.criteriaChanged}])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_base_card_header, null, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_1, [
                  _createTextVNode(_toDisplayString(_ctx.$t('filters')) + " ", 1),
                  (_ctx.criteriaChanged)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_ctx.$t('adjusted')) + ")", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "btn btn-sm btn-icon btn-danger",
                    type: "reset",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearCriteria && _ctx.clearCriteria(...args)), ["prevent"]))
                  }, _hoisted_5),
                  _hoisted_6
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_base_card_body, null, {
              default: _withCtx(() => [
                _createVNode(_component_InputNumber, {
                  modelValue: _ctx.catalogProductsCriteria.filter_cnk_code,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.catalogProductsCriteria.filter_cnk_code) = $event)),
                  label: _ctx.$t('cnkCode'),
                  name: "filter_cnk_code",
                  class: "mt-1",
                  "can-clear": "",
                  errors: errors,
                  onInput: _ctx.onCriteriaChanged
                }, null, 8, ["modelValue", "label", "errors", "onInput"]),
                _createVNode(_component_InputText, {
                  modelValue: _ctx.catalogProductsCriteria.search_keyword,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.catalogProductsCriteria.search_keyword) = $event)),
                  label: _ctx.$t('keyword'),
                  name: "search_keyword",
                  "can-clear": "",
                  errors: errors,
                  onInput: _ctx.onCriteriaChanged
                }, null, 8, ["modelValue", "label", "errors", "onInput"]),
                _createVNode(_component_SelectBrands, {
                  "selected-brand-codes": _ctx.catalogProductsCriteria.filter_labo_code ? [_ctx.catalogProductsCriteria.filter_labo_code] : [],
                  "catalog-customer-code": _ctx.catalogCustomerCode,
                  class: _normalizeClass([{'brand-selected': _ctx.catalogProductsCriteria.filter_labo_code}, "mb-3"]),
                  "btn-class": "btn btn-icon btn-outline-primary",
                  onAddBrand: _ctx.setLaboCode,
                  onRemoveBrand: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLaboCode(undefined)))
                }, null, 8, ["selected-brand-codes", "catalog-customer-code", "class", "onAddBrand"]),
                _createVNode(_component_SelectTrademarks, {
                  "selected-trademark-codes": _ctx.catalogProductsCriteria.filter_trademark_code ? [_ctx.catalogProductsCriteria.filter_trademark_code] : [],
                  "catalog-customer-code": _ctx.catalogCustomerCode,
                  class: _normalizeClass([{'trademark-selected': _ctx.catalogProductsCriteria.filter_trademark_code}, "mb-3"]),
                  "btn-class": "btn btn-icon btn-outline-primary",
                  onAddTrademark: _ctx.setTrademarkCode,
                  onRemoveTrademark: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTrademarkCode(undefined)))
                }, null, 8, ["selected-trademark-codes", "catalog-customer-code", "class", "onAddTrademark"]),
                _createVNode(_component_SelectCategories, {
                  "selected-product-categories": _ctx.catalogProductsCriteria.filter_category_code ? [_ctx.catalogProductsCriteria.filter_category_code] : [],
                  "catalog-customer-code": _ctx.catalogCustomerCode,
                  class: _normalizeClass([{'category-selected': _ctx.catalogProductsCriteria.filter_category_code}, "mb-2"]),
                  "btn-class": "btn btn-icon btn-sm btn-outline-primary w-100",
                  "btn-icon": "category",
                  onAddCategory: _ctx.setCategoryCodeDpManaged,
                  onRemoveCategory: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setCategoryCodeDpManaged(undefined)))
                }, null, 8, ["selected-product-categories", "catalog-customer-code", "class", "onAddCategory"]),
                _createVNode(_component_InputCheckboxBoolean, {
                  modelValue: _ctx.catalogProductsCriteria.filter_is_products_in_subcategory_expected,
                  "onUpdate:modelValue": [
                    _cache[6] || (_cache[6] = ($event: any) => ((_ctx.catalogProductsCriteria.filter_is_products_in_subcategory_expected) = $event)),
                    _ctx.onCriteriaChanged
                  ],
                  label: _ctx.$t('includeSubcategories'),
                  name: "filter_is_products_in_subcategory_expected",
                  class: "mb-4",
                  errors: errors
                }, null, 8, ["modelValue", "label", "errors", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["class"])
      ]),
      _: 1
    }, 8, ["onSubmit"])
  ], 64))
}